import "@/App.css";
import "@/pages/guide.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Guide from "@/pages/Guide";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/the-considered-home" element={<Guide />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
